import React, { useState } from "react";
import { FiEdit } from "react-icons/fi";
import { IoDocumentLockOutline } from "react-icons/io5";
import DimensionModel from "../DimensionModel";
import { RiFileInfoLine } from "react-icons/ri";
import { FaRegEye } from "react-icons/fa";

const LayoutUnitTable = ({ units = [], onEdit, onAdd, totalUnitRow = 0 }) => {
  const tableRows = Array.from({ length: totalUnitRow }, (_, index) => {
    const unit = units[index] || null;
    return {
      id: unit?.id || `placeholder-${index}`,
      unitNo: unit?.unitNo || "N/A",
      sqft: unit?.sqft || "N/A",
      ratePerSqft: unit?.ratePerSqft || "N/A",
   //   guidelineSqftPrice: unit?.guidelineSqftPrice || "N/A",
      registrationCharge: unit?.registrationCharge || "N/A",
      northDimension: unit?.northDimension || "N/A",
      southDimension: unit?.southDimension || "N/A",
      eastDimension: unit?.eastDimension || "N/A",
      westDimension: unit?.westDimension || "N/A",
      roadFacingSide: unit?.roadFacingSide || { id: "", name: "N/A" },
      preferredLocationCharge: unit?.preferredLocationCharge || "N/A",
      statusName: unit?.unitStatus?.name || "N/A",
      unitStatus: unit?.unitStatus || { id: "", name: "N/A" },
      order: unit?.order || index + 1,
      isPlaceholder: !unit || unit.isArchived,
      vendorGuideline: unit?.vendorGuideline || "N/A",
      governmentGuideline: unit?.governmentGuideline || "N/A",
      roadFacing: unit?.roadFacing || "N/A",
      notes : unit?.notes || "N/A",
    };
  });

  const [selectedDimension, setSelectedDimension] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  console.log(tableRows);

  const calculateTotalPrice = (sqft, ratePerSqft) => {
    if (sqft !== "N/A" && ratePerSqft !== "N/A") {
      return (parseFloat(sqft) * parseFloat(ratePerSqft)).toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      );
    }
    return "N/A";
  };

  const getStatusStyles = (status) => {
    switch (status) {
      case "Available":
        return "border-[#399E79] border bg-green-50 text-green-800";
      case "Agreement":
        return "border-[#FFDF94] border bg-yellow-50 text-yellow-800";
      case "Booked":
        return "border-[#EE6C4D] border bg-red-50 text-red-800";
      default:
        return "border-[#2280FF] border bg-blue-50 text-blue-800";
    }
  };

  // Helper to get dimension display
  const getRoadFacingDisplay = (row) => {
    if (row.roadFacingSide.name === "N/A") return "N/A";

    const dimension =
      row.roadFacingSide.name === "North"
        ? row.northDimension
        : row.roadFacingSide.name === "South"
        ? row.southDimension
        : row.roadFacingSide.name === "West"
        ? row.westDimension
        : row.eastDimension;

    return `${row.roadFacingSide.name} Facing ${dimension} Road`;
  };

  return (
    <div className="bg-white rounded-[10px] p-6 shadow-sm">
      <div className="overflow-x-auto">
        <table className="w-full ">
          <thead>
            <tr className="bg-gray-100  text-base text-center rounded-md">
              <th className="px-4 py-3 text-gray-700 font-medium">Unit No.</th>
              <th className="px-4 py-3 text-gray-700 font-medium">SQ. FT</th>
              <th className="px-4 py-3 text-gray-700 font-medium">
                Rate Per SQ.FT
              </th>
              <th className="px-4 py-3 text-gray-700 font-medium">
                Total Price
              </th>
              {/* <th className="px-4 py-3 text-gray-700 font-medium">
                GI. SQ.FT Price
              </th>
              <th className="px-4 py-3 text-gray-700 font-medium">
                Reg. Charge
              </th> */}
              <th className="px-4 py-3 text-gray-700 font-medium">Dimension</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Status</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Action</th>
            </tr>
          </thead>
          <tbody>
            {tableRows.length > 0 ? (
              tableRows.map((row) => (
                <tr
                  key={row.id}
                  className="border-b text-center border-gray-200 hover:bg-gray-50"
                >
                  <td className="px-4 text-sm py-4">{row.unitNo || ""}</td>
                  <td className="px-4 py-4 text-sm ">{row.sqft}</td>
                  <td className="px-4 py-4 text-sm">{row.ratePerSqft}</td>
                  <td className="px-4 py-4 ftext-sm">
                    {calculateTotalPrice(row.sqft, row.ratePerSqft)}
                  </td>
                  {/* <td className="px-4 py-4 text-sm">
                    {row.guidelineSqftPrice}
                  </td>
                  <td className="px-4 py-4 text-sm font-medium">
                    {row.registrationCharge}
                  </td> */}
                  <td
                    onClick={() => {
                      setSelectedDimension(row);
                      setIsOpen(true);
                    }}
                    className="px-4 py-4 text-sm"
                  >
                    <div className="flex cursor-pointer items-center justify-center">
                      <div className="relative">
                        <div className="flex flex-col items-center justify-center gap-1 p-2">
                          <div className="relative w-12 h-12 bg-gradient-to-br from-purple-100 via-purple-200 to-purple-300 rounded-md shadow-md flex items-center justify-center text-center">
                            <div className="absolute truncate w-12 -top-1 left-0 right-0 -translate-y-4 text-[10px] font-medium text-center">
                              N-{row.northDimension || "N/A"}
                            </div>
                            <div className="absolute truncate w-12 -bottom-1 left-0 right-0 translate-y-4 text-[10px] font-medium text-center">
                              S-{row.southDimension || "N/A"}
                            </div>
                            <div className="absolute truncate w-12 -left-3 top-1/2 transform -translate-x-full -translate-y-1/2 flex items-center justify-end text-[10px] font-medium text-left">
                              W-{row.westDimension || "N/A"}
                            </div>
                            <div className="absolute truncate w-12 -right-3 top-1/2 transform translate-x-full -translate-y-1/2 flex items-center text-[10px] font-medium text-right">
                              E-{row.eastDimension || "N/A"}
                            </div>
                            <div className="text-[10px] font-bold text-gray-800 leading-tight">
                              {row.sqft !== "N/A" ? row.sqft : "N/A"}
                              <br />
                              Sq.ft
                            </div>
                          </div>

                          <div className="bg-gray-700 text-white  truncate w-20 font-medium text-[10px] px-2 rounded shadow mt-4 whitespace-nowrap">
                            {row.roadFacing}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-4">
                    <span
                      className={`px-3 py-1 text-xs rounded-full ${getStatusStyles(
                        row.unitStatus.name
                      )}`}
                    >
                      {row.unitStatus?.name}
                    </span>
                  </td>
                  {row.unitStatus?.name === "Available" ||
                  row?.unitStatus?.name === "N/A" ? (
                    <td className="px-4 py-4">
                      {row.isPlaceholder ? (
                        <button
                          onClick={() =>
                            onAdd({
                              order: row.order,
                              unitNo: "",
                              sqft: 0,
                              ratePerSqft: 0,
                              guidelineSqftPrice: 0,
                              northDimension: 0,
                              eastDimension: 0,
                              westDimension: 0,
                              southDimension: 0,
                              roadFacingSide: { id: "", name: "" },
                              preferredLocationCharge: 0,
                              // roadWidth: 0,
                              createdBy: "",
                              unitStatus: { id: "", name: "" },
                              propertyId: "",
                              statusName: "Available",
                              registrationCharge: 0,
                              notes : "",
                            })
                          }
                          className="p-1 px-2 bg-customGreen text-white rounded-md  transition-colors flex items-center justify-center"
                          aria-label="Add unit"
                        >
                          <span className="text-sm">Add</span>
                        </button>
                      ) : (
                        <button
                          onClick={() => onEdit(row)}
                          className="p-2 text-customGreen hover:bg-blue-50 rounded-md transition-colors"
                          aria-label="Edit unit"
                        >
                          <FiEdit size={20} />
                        </button>
                      )}
                    </td>
                  ) : (
                    <td
                      onClick={() => onEdit(row)}
                      className="text-center hover:text-customGreen flex mt-14 justify-center  items-center  text-2xl  cursor-pointer"
                    >
                      <FaRegEye />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr className="text-center">
                <td colSpan={9} className="py-8 text-gray-500">
                  No units found
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            {onAdd && (
              <tr>
                <td colSpan={9} className="px-4 py-4 text-center">
                  <button
                    onClick={() =>
                      onAdd({
                        order: tableRows.length + 1,
                        unitNo: "",
                        sqft: 0,
                        ratePerSqft: 0,
                        //  guidelineSqftPrice: 0,
                        northDimension: 0,
                        eastDimension: 0,
                        westDimension: 0,
                        southDimension: 0,
                        roadFacingSide: { id: "", name: "" },
                        roadWidth: 0,
                        createdBy: "",
                        unitStatus: { id: "", name: "" },
                        propertyId: "",
                        registrationCharge: 0,

                        vendorGuideline: 0,
                        governmentGuideline: 0,
                      })
                    }
                    className="px-4 py-2 bg-customGreen text-white rounded-md transition-colors flex items-center mx-auto"
                  >
                    Add New Unit
                  </button>
                </td>
              </tr>
            )}
          </tfoot>
        </table>
      </div>
      <DimensionModel
        isOpen={isOpen}
        row={selectedDimension}
        isClose={() => setIsOpen(false)}
      />
    </div>
  );
};

export default LayoutUnitTable;
